"use strict";

const MODAL_SELECTOR = "[data-resource-modal]";
const FORM_SELECTOR = "[data-resource-form]";
const NOTIFY_SELECTOR = "[data-resource-form-notify]";
const SUBMIT_SELECTOR = "[data-resource-form-submit]";
const COMPANY_FIELD_SELECTOR = "[data-resource-company-field]";
const COMPANY_WRAP_SELECTOR = "[data-resource-company-wrap]";
const CUSTOMER_TYPE_SELECTOR = "[data-resource-customer-type]";
const RESOURCE_ID_FIELD_SELECTOR = "[data-resource-id-field]";
const TRIGGER_SELECTOR = "[data-resource-download]";

const AJAX_ACTION = "resource_download_action";
const AUTO_CLOSE_MS = 5000;

function getRecaptchaResponse(form) {
    if (!window.WPURLS?.recaptcha?.enabled || typeof window.grecaptcha === "undefined") {
        return "";
    }

    const widget = form.querySelector(".g-recaptcha");

    return widget ? window.grecaptcha.getResponse() : "";
}

function resetRecaptcha(form) {
    if (!window.WPURLS?.recaptcha?.enabled || typeof window.grecaptcha === "undefined") {
        return;
    }

    if (form.querySelector(".g-recaptcha")) {
        window.grecaptcha.reset();
    }
}

function setNotify(notify, type, message) {
    if (!notify) {
        return;
    }

    notify.className = "form-notify";

    if (type) {
        notify.classList.add(type);
    }

    notify.textContent = message || "";
}

function updateCompanyFieldVisibility(form) {
    const companyField = form.querySelector(COMPANY_FIELD_SELECTOR);
    const companyWrap = form.querySelector(COMPANY_WRAP_SELECTOR);
    const selectedType = form.querySelector(`${CUSTOMER_TYPE_SELECTOR}:checked`);

    if (!companyField) {
        return;
    }

    const isCompany = selectedType?.value === "company";
    companyField.required = isCompany;

    if (companyWrap) {
        companyWrap.hidden = !isCompany;
    }

    if (!isCompany) {
        companyField.value = "";
        companyField.classList.remove("is-invalid");
    }
}

function getModalInstance(modal) {
    if (!window.bootstrap?.Modal) {
        return null;
    }

    return window.bootstrap.Modal.getOrCreateInstance(modal);
}

function initResourceDownload() {
    const modal = document.querySelector(MODAL_SELECTOR);
    const form = modal ? modal.querySelector(FORM_SELECTOR) : null;

    if (!modal || !form) {
        return;
    }

    const notify = form.querySelector(NOTIFY_SELECTOR);
    const submitButton = form.querySelector(SUBMIT_SELECTOR);
    const resourceIdField = form.querySelector(RESOURCE_ID_FIELD_SELECTOR);
    let autoCloseTimer = null;

    form.querySelectorAll(CUSTOMER_TYPE_SELECTOR).forEach((input) => {
        input.addEventListener("change", () => updateCompanyFieldVisibility(form));
    });

    updateCompanyFieldVisibility(form);

    // Apertura modale dai pulsanti download (delegation: resiste ai re-render).
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest(TRIGGER_SELECTOR);

        if (!trigger) {
            return;
        }

        event.preventDefault();

        if (resourceIdField) {
            resourceIdField.value = trigger.getAttribute("data-resource-id") || "";
        }

        setNotify(notify, "", "");

        const instance = getModalInstance(modal);

        if (instance) {
            instance.show();
        }
    });

    modal.addEventListener("shown.bs.modal", () => {
        const firstField = form.querySelector("input:not([type=hidden]), select, textarea");

        if (firstField instanceof HTMLElement) {
            firstField.focus();
        }
    });

    modal.addEventListener("hidden.bs.modal", () => {
        if (autoCloseTimer) {
            window.clearTimeout(autoCloseTimer);
            autoCloseTimer = null;
        }

        form.reset();
        updateCompanyFieldVisibility(form);
        resetRecaptcha(form);
        setNotify(notify, "", "");
    });

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!window.WPURLS?.ajaxUrl) {
            return;
        }

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const recaptchaResponse = getRecaptchaResponse(form);

        if (window.WPURLS.recaptcha?.enabled && !recaptchaResponse) {
            setNotify(notify, "error", window.WPURLS.recaptcha.error);
            return;
        }

        const defaultMessage = window.WPURLS.mail_message?.error || "";
        const sendingMessage = window.WPURLS.mail_message?.sending || "";

        if (submitButton) {
            submitButton.disabled = true;
        }

        setNotify(notify, "info", sendingMessage);

        const data = new FormData(form);
        data.append("action", AJAX_ACTION);

        if (recaptchaResponse) {
            data.append("g-recaptcha-response", recaptchaResponse);
        }

        try {
            const response = await fetch(window.WPURLS.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: data,
            });

            const payload = await response.json();
            const isSuccess = Boolean(payload?.success);

            setNotify(notify, isSuccess ? "success" : "error", payload?.message || defaultMessage);

            if (isSuccess) {
                autoCloseTimer = window.setTimeout(() => {
                    const instance = getModalInstance(modal);

                    if (instance) {
                        instance.hide();
                    }
                }, AUTO_CLOSE_MS);
            }
        } catch (error) {
            setNotify(notify, "error", defaultMessage);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    });
}

function init() {
    initResourceDownload();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
    init();
}
